import { Center, Text } from '@chakra-ui/react'

export const MedsTab = () => (
  <Center w="100%" h="100%">
    <Text fontSize="2xl" color="gray.400" fontWeight={500}>
      Meds
    </Text>
  </Center>
)
